import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import styles from './styles';

const MAX_BYTES = 20 * 1024 * 1024;
const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

@injectIntl
@withStyles(styles)
export default class DropZone extends Component {
  state = { dragging: false };
  inputRef = React.createRef();

  validate = file => {
    if (!file) return null;
    if (file.size > MAX_BYTES) return 'tools_imageResize_fileTooLarge';
    if (!ACCEPTED_TYPES.includes(file.type)) return 'tools_imageResize_invalidFile';
    return null;
  };

  handleFile = file => {
    const errorKey = this.validate(file);
    if (errorKey) {
      this.props.onError(errorKey);
      return;
    }
    this.props.onFile(file);
  };

  onInputChange = e => {
    const file = e.target.files && e.target.files[0];
    if (file) this.handleFile(file);
    e.target.value = '';
  };

  onClick = () => {
    if (this.inputRef.current) this.inputRef.current.click();
  };

  onDragOver = e => {
    e.preventDefault();
    e.stopPropagation();
    if (!this.state.dragging) this.setState({ dragging: true });
  };

  onDragLeave = e => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ dragging: false });
  };

  onDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ dragging: false });
    const file = e.dataTransfer.files && e.dataTransfer.files[0];
    if (file) this.handleFile(file);
  };

  render() {
    const { classes, intl: { messages: m } } = this.props;
    const { dragging } = this.state;
    return (
      <div
        className={`${classes.dropZone} ${dragging ? classes.dropZoneActive : ''}`}
        onClick={this.onClick}
        onDragOver={this.onDragOver}
        onDragEnter={this.onDragOver}
        onDragLeave={this.onDragLeave}
        onDrop={this.onDrop}
        role="button"
        tabIndex={0}
      >
        <CloudUploadIcon className={classes.dropZoneIcon} />
        <Typography variant="body1">{m.tools_imageResize_dropHere}</Typography>
        <input
          ref={this.inputRef}
          type="file"
          accept={ACCEPTED_TYPES.join(',')}
          className={classes.hiddenInput}
          onChange={this.onInputChange}
        />
      </div>
    );
  }
}
